"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const store_1 = require("../../context/store");
const actions_1 = require("../../context/actions");
const intl_1 = require("../../helpers/intl");
const SlideDrawer_1 = __importDefault(require("../SlideDrawer"));
const SearchBar_1 = __importDefault(require("../SearchBar"));
const SectionTitle_1 = __importDefault(require("../SectionTitle"));
const FiatRow_1 = __importDefault(require("./FiatRow"));
const styled_1 = require("./styled");
const FiatList = ({ show, setShow }) => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const { geoCurrency } = (0, store_1.useTrackedState)();
    const dispatch = (0, store_1.useDispatch)();
    const [searchFiat, setSearchFiat] = (0, react_1.useState)("");
    const handleSelect = (0, react_1.useCallback)((fiat) => {
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_SELECTED_FIAT,
            payload: fiat.abbr,
        });
        setSearchFiat("");
        setShow(false);
    }, [dispatch, setShow]);
    const currencies = (0, react_1.useMemo)(() => {
        if (!geoCurrency || !(geoCurrency === null || geoCurrency === void 0 ? void 0 : geoCurrency.currency))
            return [];
        const allCurrencies = (0, intl_1.getCurrenciesList)(geoCurrency.currency);
        return Object.values(allCurrencies).filter((coin) => coin.label.toUpperCase().includes(searchFiat.toUpperCase()) ||
            coin.abbr.toUpperCase().includes(searchFiat.toUpperCase()));
    }, [geoCurrency, searchFiat]);
    return (react_1.default.createElement(SlideDrawer_1.default, { title: formatMessage({ id: "buy.fiat-select" }), show: show, closeFn: () => {
            setSearchFiat("");
            setShow(false);
        } },
        react_1.default.createElement(SearchBar_1.default, { searchType: "fiat", setSearchResult: (query) => {
                setSearchFiat(query);
            } }),
        react_1.default.createElement(styled_1.DrawerContent, null, currencies.length === 0 ? (react_1.default.createElement(SectionTitle_1.default, { title: "buy.fiat-none" })) : (react_1.default.createElement(react_1.default.Fragment, null, currencies.map((fiat) => (react_1.default.createElement(FiatRow_1.default, { key: fiat.abbr, fiat: fiat, callback: () => handleSelect(fiat) }))))))));
};
exports.default = FiatList;
//# sourceMappingURL=FiatList.js.map